export default "__VITE_ASSET__Cvqfoh4Q__"